<template>
  <b-row align-content="start" border-variant="primary" class="py-1 mb-2 border-bottom border-light text-left">
    <b-col cols="4" class="text-dark font-weight-bold">{{ title }}</b-col>
    <b-col cols="6">
      <div class="text-dark"><b-icon icon="circle-fill" :style="statusColor" style="width: .5em;"/> {{ statusLabel }}</div>
    </b-col>
    <b-col cols="2">
    </b-col>
  </b-row>
</template>

<script>

export default {
  name: "IdentityStatusRowItem",
  props: {
    title: {type: String},
    data: {type: String}
  },
  computed: {
    statusLabel() {
      return this.data === 'BLOCKED' ? this.$t('identity.statusBlocked') : this.$t('identity.statusActive')
    },
    statusColor() {
      return this.data === 'BLOCKED' ? 'color: red;' : 'color: green;'
    }
  },
  methods: {
  }
}
</script>

<style scoped>

</style>